// src/components/ScrollToTop.js
import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

/**
 * Attempts to scroll these targets to top, in order.
 * - If `hash` exists, it scrolls to that element instead.
 */
export default function ScrollToTop({
  targets = ["[data-scroll-root]", ".page-wrapper", "main", "body", "html"],
  behavior = "auto", // or "smooth"
}) {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // If you navigated to /page#section, honor the anchor
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior });
        return;
      }
    }

    // Try container targets first (for apps that scroll inside a div)
    for (const sel of targets) {
      const node =
        sel === "body" ? document.body :
        sel === "html" ? document.documentElement :
        document.querySelector(sel);

      if (node && typeof node.scrollTo === "function") {
        node.scrollTo({ top: 0, left: 0, behavior });
        // also reset scrollTop in case scrollTo isn't supported on it
        if ("scrollTop" in node) node.scrollTop = 0;
      }
    }

    // Always fall back to window
    window.scrollTo({ top: 0, left: 0, behavior });
    // eslint-disable-next-line
  }, [pathname, hash]);

  return null;
}